import client from "./client";

export async function executeBatchCreateSchedule(form) {
  const res = await client.post("/api/batch/assing_on_duty/", form);
  return res.data;
}
